export function ExtractPath(tikz) {
  const regex = /\\path([\s\S]*?);/g;
  let arrayTransitions = Array.from(
    tikz.matchAll(regex), // Extrair todas as transições entre /path e ;
    (match) => match[1]
  );
  let strTransitions = arrayTransitions.join("\n");
  return strTransitions;
}
